<template>
    <v-container fluid grid-list-md>
        <v-layout row wrap>
            <v-flex xs12>
                <v-card>
                     <v-card-text>
                         <v-container fluid v-if="reservation.show || 1">
                              <v-layout row wrap>
                                  <v-col cols="12">
                                       <h2>Edit Additional Fees and Taxes ({{ reservation.additional_fees.length }})</h2>
                                        <p>All prices are in {{ reservation.hotel.hotel_name }}'s local currency {{ reservation.hotel.currency.currency_name }}</p>
                                        <p>Note: this is for display only, and does not yet save</p>
                                        <p>Note: this does not yet support the old taxes set up through legacy admin; only new taxes and fees applied as new Additional Fees in Portal</p>
                                  </v-col>


                                   <v-col cols="12">
                                       <h3>Add New Property Fees and Taxes</h3>
                                   </v-col>
                                   <v-col cols="12" v-if="!hotelFees.length">{{ reservation.hotel.hotel_name }} does not have any standard fees or taxes</v-col>

                                   <v-col cols="12" v-if="hotelFees.length">
                                       {{ reservation.hotel.hotel_name }} supports the following fees and taxes.  Click the + Apply button to add it to this reservation, or click the Add Customised Fee button at the bottom to create a bespoke fee.
                                       <fieldset v-for="fee,index in hotelFees">
                                           <legend>{{ fee.name }}</legend>
                                         <v-layout row>
                                           <v-col cols="12">{{ fee.description }}</v-col>
                                           <v-col cols="10">
                                               {{ fee.fee_value }} {{ fee.fee_application_type == 2 ? "%" : reservation.hotel.currency.currency_code }}
                                               {{ feeCategoryAsString(fee.hotel_additional_fee_type_key) }}, 
                                               billed {{ feeTypeAsString(fee.fee_application_type) }},
                                               payable to {{ feePayableAsString(fee.is_payable_to) }}
                                           </v-col>
                                           <v-col cols="2">
                                               <v-btn v-on:click="applyHotelFee(fee)"
                                                   title="Apply this fee to the reservation"
                                               >
                                                   <v-icon>add</v-icon> Apply
                                               </v-btn>
                                           </v-col>
                                         </v-layout>
                                       </fieldset>

                                       <fieldset>
                                           <legend>Custom</legend>
                                           <v-col cols="10">Apply a new blank fee which can be customised as needed</v-col>

                                           <v-col cols="2">
                                               <v-btn v-on:click="addNewCustomFee()"
                                                   title="Add a new customised fee you can configure yourself"
                                               >
                                                   <v-icon>add</v-icon> Apply Customised Fee
                                               </v-btn>
                                           </v-col>
                                       </fieldset>
                                   </v-col>

                                   <v-col cols="12" class="mt-4">
                                       <h3>Edit The Fees and Taxes Applied to This Booking</h3>
                                   </v-col>

                                   <v-col cols="12">
                                       <fieldset v-for="fee,index in reservation.additional_fees">
                                           <legend>Fee {{ (index + 1) }}</legend>
                                       <v-layout row>

                                           <v-col cols="4">
                                               <v-text-field v-model="fee.name" 
                                                             label="Name"
                                               ></v-text-field>
                                           </v-col>

                                           <v-col cols="8">
                                               <v-text-field v-model="fee.description" 
                                                             label="Description"
                                               ></v-text-field>
                                           </v-col>

                                           <v-col cols="2">
                                               <v-autocomplete dense outlined
                                                   v-model="fee.hotel_additional_fee_type_key"
                                                   label="Category"
                                                   :items="categoryOptions"
                                                   autocomplete
                                               ></v-autocomplete>
                                           </v-col>


                                           <v-col cols="2">
                                               <v-text-field  
                                                   v-model="fee.fee_value" 
                                                   label="Value"></v-text-field>
                                               {{ fee.fee_application_type == 2 ? "%" : reservation.hotel.currency.currency_code }}
                                           </v-col>

                                           <v-col cols="3">
                                               <v-autocomplete dense outlined
                                                   v-model="fee.fee_application_type"
                                                   label="Application"
                                                   :items="applicationOptions"
                                                   autocomplete
                                               ></v-autocomplete>
                                           </v-col>


                                           <v-col cols="3">
                                               <v-autocomplete dense outlined
                                                               v-model="fee.is_payable_to"
                                                               label="Payee"
                                                               :items="payeeOptions"
                                                               autocomplete
                                               ></v-autocomplete>
                                           </v-col>
                                           <v-col cols="2">
                                               <v-btn v-on:click="removeFee(index)" 
                                                  title="Remove this fee from the reservation"
                                               >
                                                  <v-icon>delete</v-icon> Remove
                                               </v-btn>
                                           </v-col>
                                       </v-layout>
                                       </fieldset>
                                   </v-col>

                                   <v-col cols="12">
                                       <v-btn class="" 
                                              v-on:click="cancel"
                                              title="Cancel without changes">Cancel</v-btn>

                                       <v-btn v-on:click="save"
                                           class="ies-green"
                                           title="Save changes to taxes and fees"
                                        >
                                           <v-icon>save</v-icon> Save
                                       </v-btn>
                                   </v-col>
                              </v-layout>
                          </v-container>
                      </v-card-text>
                 </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    /**
     * A Vue component dedicated to letting the user manage a reservations
     * by the ID specified
     *
     * Props:
     *     int 'reservationkey' - The ID of the reservation to display
     */

    import axios from 'axios';
    import EventBus from '@/eventBus';
    export default {
        name: 'hotel-reservation-fees',
        props: ['reservationkey'],
        data () {
            return {
                reservation: {},
                hotelFees: [],
                hotelFeeOptions: [],
                payeeOptions: [{text: "None - included in quote", value: 1}, {text: "Fee added to quote", value: 2}, {text: "Paid directly to the property", value: 3}, {text: "Unknown - property to confirm", value: 4}],
                applicationOptions: [{text: "None", value: 1}, {text: "Percentage of Quote", value: 2},/* {text: "Extra", value: 3},*/ {text: "Per Room", value: 4}, {text: "Per Unit", value: 5}, {text: "Per Person Per Night", value: 6}, {text: "Per Person Per Stay", value: 7}, {text: "Per Stay", value: 8}],
                categoryOptions: [{text: "Government Tax", value: 1}, {text: "Service Charge", value: 2}, {text: "City/Tourist Tax", value: 3}, {text: "Cleaning Fee", value: 4}, {text: "Miscellaneous", value: 5}],
            }
        },
        methods: {

            loadReservation(){
                axios.get('/api/reservations/id/' + this.reservationkey)
                .then(function(response){
                    this.reservation = response.data.reservation;
                    console.log("Additional fees", this.reservation);
                    this.loadFeeTypes();
                }.bind(this));
            },

            /**
             * loads the fees this hotel supports
             */
            loadFeeTypes(){
                axios.get('/api/hotels/' + this.reservation.hotel_key)
                .then(function(response){
                    console.log(response);
                    this.hotelFees = response.data.additional_fees;

                    this.hotelFeeOptions = [{ text: "Custom", value: 0 }];
                    this.hotelFees.forEach(function(fee){
                        this.hotelFeeOptions.push({ text: fee.name, value: fee.hotel_additional_fee_key });
                    }.bind(this));
                }.bind(this));
            },

            applyHotelFee(fee){
                this.reservation.additional_fees.push(fee);
            },

            /**
             * Adds a new blank customised fee entry against the reservation so that 
             * the user can set it up the way they need to regardless of any standard
             * fees and taxes the hotel normally applies
             */
            addNewCustomFee(){
                this.reservation.additional_fees.push({ "hotel_additional_fee_key": 2, "reservation_additional_fee_key": null, "name": "", "description": "", "fee_application_type": 8, "fee_value": 0.0, "application_type": 5, "is_payable_to": 3 });
            },

            cancel(){
                EventBus.$emit('Reservation Administration: Task change', {'reservationKey': this.reservationkey, 'taskName': 'manage reservation'});
            },

            /**
             * @method save
             *
             * Saves changes to the reservations taxes and fees by submitting the users
             * data from here to the dedicated api endpoint
             */
            save(){
               alert("Sorry, this feature is not yet available");
            },

            feeCategoryAsString(feeCategory){
                switch(feeCategory){
                    case 1: return "government tax";
                    case 2: return "service charge";
                    case 3: return "city/tourist tax";
                    case 4: return "cleaning fee";
                    case 5: return "miscellaneous fee";
                }
                return "Not set";
            },
            feeTypeAsString(applicationType){
                switch(applicationType){
                    case 1: return "none";
                    case 2: return "percentage of quote";
                    case 3: return "extra";
                    case 4: return "per room";
                    case 5: return "per unit";
                    case 6: return "per person per night";
                    case 7: return "per person per stay";
                    case 8: return "per stay";
                }
                return "Not set";
            },
            feePayableAsString(isPayableTo){
                switch(isPayableTo){
                    case 1: return "included in quote";
                    case 2: return "added to quote";
                    case 3: return "the property";
                    case 4: return "unknown (property to confirm)";
                }
                return "Not set";
            }
        },

        /**
         * Once mounted this component needs to load the reservation specified
         */
        mounted() {
            this.loadReservation();
        },


        computed: {}
    }
</script>
